import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  readonly logoSrc = 'assets/images/logo-scenario-university.svg';
  readonly avatarSrc = 'assets/icons/32px/user_icon_placeholder.svg';
}
